import AntdCol      from 'antd/lib/col';
import React        from 'react';
import useDashboard from '@widesk-ui/hooks/useDashboard';

type ColProps = {
	span?: ColSize;
	xs?: ColSize;
	sm?: ColSize;
	md?: ColSize;
	lg?: ColSize;
	xl?: ColSize;
	xxl?: ColSize;
	children: React.ReactNode;
}

export function Col(props: ColProps) {
	const { dashboardStore } = useDashboard();

	const xxl = props.xxl || (dashboardStore ? 12 : undefined);
	const xl = props.xl || (dashboardStore ? ((xxl && xxl > 12) ? undefined : 12) : undefined);
	const lg = props.lg || (dashboardStore ? 24 : undefined);
	const md = props.md || (dashboardStore ? 24 : undefined);
	const sm = props.sm || (dashboardStore ? 24 : undefined);
	const xs = props.xs || (dashboardStore ? 24 : undefined);

	return (
		<AntdCol
			span={props.span as any}
			xs={xs}
			sm={sm}
			md={md}
			lg={lg}
			xl={xl}
			xxl={xxl}
		>
			{props.children}
		</AntdCol>
	);
}
